import { render, staticRenderFns } from "./BaseTabPicker.vue?vue&type=template&id=6d22c038&scoped=true"
import script from "./BaseTabPicker.vue?vue&type=script&lang=js"
export * from "./BaseTabPicker.vue?vue&type=script&lang=js"
import style0 from "./BaseTabPicker.vue?vue&type=style&index=0&id=6d22c038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22c038",
  null
  
)

export default component.exports